import { takeEvery, call, put, fork } from "redux-saga/effects";
import { EventManagementActions } from "../../actions/types";
import * as api from "../../api/event-management";
import * as actions from "../../actions/event-management";
import { createEventPayload, updateEventPayload } from "../../actions/event-management";
import { EventStoreError, EventStoreSuccess } from "../../enums/store-messages/event-management";
import { EventInformation } from "../../reducers/states/event-management";
import { IsResponseValidUtil } from "../../utils/api-utils";

export function* getEvent(action: {
  type: typeof EventManagementActions.GET_EVENT;
  payload: { id: string };
}): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.getEvent, action.payload.id);
    if (result && result.status === 200) {
      yield put(actions.getEventSuccess(result.data as EventInformation));
    } else {
      yield put(actions.getEventFailure(EventStoreError.GET_EVENT_ERROR));
    }
  } catch {
    yield put(actions.getEventFailure(EventStoreError.GET_EVENT_ERROR));
  }
}

export function* getEvents(action: { type: typeof EventManagementActions.GET_EVENTS }): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.getEvents);
    if (result && result.status === 200) {
      yield put(actions.getEventsSuccess(result.data as EventInformation[]));
    } else {
      yield put(actions.getEventsFailure(EventStoreError.GET_EVENTS_ERROR));
    }
  } catch {
    yield put(actions.getEventsFailure(EventStoreError.GET_EVENTS_ERROR));
  }
}

export function* createEvent(action: {
  type: typeof EventManagementActions.CREATE_EVENT;
  payload: createEventPayload;
}): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.createEvent, {
      ...action.payload,
    } as createEventPayload);

    // todo: Response should be a 201 and result.data should maybe not be an object, unless we update it to return the created object.
    if (result && result.status === 200 && IsResponseValidUtil(result.data)) {
      yield put(actions.createEventSuccess(EventStoreSuccess.ADD_EVENT_SUCCESS));
      yield put(actions.getEventsRequest());
    } else {
      yield put(actions.createEventFailure(EventStoreError.ADD_EVENT_ERROR));
    }
  } catch {
    yield put(actions.createEventFailure(EventStoreError.ADD_EVENT_ERROR));
  }
}

export function* deleteEvent(action: {
  type: typeof EventManagementActions.DELETE_EVENT;
  payload: { id: string };
}): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.deleteEvent, action.payload.id);

    // todo: Response should be a 204 and result.
    if (result && (result.status === 200 || result.status === 204)) {
      yield put(actions.deleteEventSuccess(action.payload.id, EventStoreSuccess.DELETE_EVENT_SUCCESS));
    } else {
      yield put(actions.deleteEventFailure(action.payload.id, EventStoreError.DELETE_EVENT_ERROR));
    }
  } catch {
    yield put(actions.deleteEventFailure(action.payload.id, EventStoreError.DELETE_EVENT_ERROR));
  }
}

export function* updateEvent(action: {
  type: typeof EventManagementActions.UPDATE_EVENT;
  id: string;
  payload: updateEventPayload;
}): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.updateEvent, action.id, {
      ...action.payload,
    } as updateEventPayload);
    if (result && result.status === 200 && IsResponseValidUtil(result.data)) {
      yield put(actions.updateEventSuccess(EventStoreSuccess.UPDATE_EVENT_SUCCESS));
      yield put(actions.getEventsRequest());
    } else {
      yield put(actions.updateEventFailure(EventStoreError.UPDATE_EVENT_ERROR));
    }
  } catch {
    yield put(actions.updateEventFailure(EventStoreError.UPDATE_EVENT_ERROR));
  }
}

function* watchCreateEvent() {
  yield takeEvery(EventManagementActions.CREATE_EVENT, createEvent);
}

function* watchDeleteEvent() {
  yield takeEvery(EventManagementActions.DELETE_EVENT, deleteEvent);
}

function* watchGetEvents() {
  yield takeEvery(EventManagementActions.GET_EVENTS, getEvents);
}

function* watchUpdateEvent() {
  yield takeEvery(EventManagementActions.UPDATE_EVENT, updateEvent);
}

const eventManagementSagas = [
  fork(watchCreateEvent),
  fork(watchDeleteEvent),
  fork(watchGetEvents),
  fork(watchUpdateEvent),
];

export default eventManagementSagas;
